const getPathIdentifier = field => `${field.objectTypeId}/${field.name}`;
export default getPathIdentifier;